import NoScoreImage from "../../../../assets/images/dashboard/noscroe_screen.png";
import "../styles/NoAssessmentPage_Styles.css";
const NoAssessmentPage: React.FC = () => {
  return (
    <div className="noskillscore">
      <img src={NoScoreImage} alt="No Assessemnt" />
      <p>
        Please take up an assessment to get a personalized recommendation for
        improvement in skill abilities
      </p>
    </div>
  );
};

export default NoAssessmentPage;
